<template>
  <div>
    <div class="row">
      <div class="col-8">
        <breadcrumb :page="page" />
      </div>
      <div class="col-4 text-right mt-4">
        <button
          id="btnFA"
          class="btn btn-action btn-green pt-1"
          @click="$router.go(-1)"
        >
          <i class="fas fa-arrow-circle-left pr-1" />
          Regresar
        </button>
      </div>
    </div>
    <div class="divider" />
    <div class="mt-4">
      <div v-if="hasDocuments">
        <div v-for="documentType in documentsByType" :key="documentType.id">
          <div v-if="documentType.docs && documentType.docs.length > 0">
            <SectionTitle
              :bg-icon="getBgIcon(isTypeVisible(documentType.id))"
              class="cursor-pointer"
              :icon="getIcon(isTypeVisible(documentType.id))"
              :content="documentType.name"
              container-class="tag-badge-main-info mt-2 mb-2"
              @on-click="toggleVisibility(documentType.id)"
            />
            <transition name="list">
              <div
                v-show="isTypeVisible(documentType.id)"
                class="card-body p-0 mb-4"
              >
                <div
                  v-for="(card, cardIndex) in documentType.docs"
                  :key="cardIndex"
                >
                  <RowCardItemCard status-class="gray">
                    <!-- Cuerpo de la Card -->
                    <div slot="body">
                      <div class="col-12 p-0 d-flex">
                        <div class="pl-0 py-0 col-md-5 col-sm-12">
                          <div class="d-flex flex-column">
                            <span class="data-title">Título:</span>
                            <span class="data-content">
                              {{ card.documentTitle }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div slot="actions">
                      <div class="dropdown text-right">
                        <button
                          class="btn btn-dropdown-actions dropdown-toggle float-right pt-1"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <span class="px-2">Acciones</span>
                          <i class="fa fa-angle-down" />
                        </button>
                        <div
                          class="dropdown-menu dropdown-menu-right py-2 mt-1"
                        >
                          <div
                            class="dropdown-item"
                            @click="downloadDocument(card)"
                          >
                            <em class="fa fa-download text-green pr-1" />
                            <span>Descargar Documento</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </RowCardItemCard>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="d-flex align-items-center justify-content-center mt-5 py-5">
          <div class="align-items-center d-flex">
            <i class="fal big-icon mr-4 fa-folder-open text-gray-light" />
            <span class="text-gray-light message">
              No existen documentos
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumb from '@/components/common/page/TitleBreadcrumb';
import { SectionTitle } from '@/components/pei/shared';
import RowCardItemCard from '@/components/common/rowcard/RowCardItemCard';
import alert from '@/mixin/alert.mixin';

import generalService from '@/services/pei/general';

export default {
  name: 'Documents',
  mixins: [alert],
  components: {
    breadcrumb,
    SectionTitle,
    RowCardItemCard,
  },

  data() {
    return {
      page: {
        icon: 'fas fa-user-edit',
        title: 'Contestación de Remedio Provisional',
        routes: [
          'Inicio',
          'Estudiantes',
          'Contestación de Remedio Provisional',
          'Informaciones sobre las solicitudes',
          'Documentos',
        ],
        sections: ['I. Documentos'],
      },
      documents: [],
      visibleTypes: [],
    };
  },
  mounted() {
    this.getDocuments();
  },
  methods: {
    getDocuments() {
      this.$ApiGet(`api/studentanswerrp/documents/${this.requestId}`).then(
        (res) => {
          this.documents = res.data;
        }
      );
    },
    async downloadDocument(card) {
      await generalService.getDocument(card.documentId).catch((err) => {
        this.ShowToast('Error', err.response.data.message, 'error');
      });
    },
    toggleVisibility(val) {
      let idx = this.visibleTypes.indexOf(val);
      if (idx >= 0) {
        this.visibleTypes.splice(idx, 1);
      } else {
        this.visibleTypes.push(val);
      }
    },
    isTypeVisible(id) {
      return this.visibleTypes.indexOf(id) >= 0;
    },
    getBgIcon(expanded) {
      return expanded ? 'green' : 'gray';
    },
    getIcon(expanded) {
      return expanded ? 'fas fa-chevron-down' : 'fas fa-chevron-right';
    },
  },
  computed: {
    requestId() {
      return this.$route.params.requestId;
    },
    hasDocuments() {
      return this.documents.length > 0;
    },
    documentsByType() {
      return [{ id: 1, name: 'Documentos', docs: this.documents }];
    },
  },
};
</script>

<style scoped>
.gray-box {
  border-radius: 5px;
  background-color: #f7f7f7;
}
.buttons-container {
  margin-top: 29px;
}
.message {
  font-size: 16px;
}
.big-icon {
  font-size: 3em;
}
.btn-dropdown-actions i.fa-angle-down {
  font-size: 12px;
  font-weight: 400;
}
.btn-dropdown-actions::after {
  border: none;
}
.dropdown-item {
  cursor: pointer;
  padding: 0.25rem 1rem;
  font-size: 15px;
}
.dropdown-item span {
  margin-left: 10px;
}
.dropdown-item em {
  min-width: 23px;
}
.list-enter,
.list-leave-to {
  display: none;
  height: 0;
}

.list-enter-active,
.list-leave-active {
  transition: height 0.35s ease;
}

.billing-text-label {
  text-align: left;
  font-size: 1rem;
  font-weight: bold;
  letter-spacing: 0px;
  color: #11291b;
}

.billing-text-span {
  text-align: left;
  font-size: 0.9rem;
  letter-spacing: 0px;
  color: #11291b;
}

.divider {
  border: 1px solid #d9e5df;
  height: 1px;
  width: 100%;
}
</style>
